"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _EnableModal = require("./EnableModal");
var _DisableModal = require("./DisableModal");
var _Switch = require("../Switch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Component = function Component(_ref) {
  var switchChecked = _ref.switchChecked,
    isLastSwitchChecked = _ref.isLastSwitchChecked,
    toggleModal = _ref.toggleModal,
    modalOpened = _ref.modalOpened;
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Switch.Switch, {
    title: t('googleAuth.title'),
    subtitle: t('googleAuth.subtitle'),
    inputProps: {
      checked: switchChecked,
      onChange: toggleModal
    },
    isLastChecked: isLastSwitchChecked
  }), /*#__PURE__*/_react.default.createElement(_DisableModal.DisableModal, {
    toggle: toggleModal,
    isOpen: switchChecked && modalOpened
  }), /*#__PURE__*/_react.default.createElement(_EnableModal.EnableModal, {
    toggle: toggleModal,
    isOpen: !switchChecked && modalOpened
  }));
};
exports.Component = Component;